<template>
  <div :class="`panel panel-${feedbackClass.bg}`">
    <div class="panel-body">
        <div class="panel-title" :class="`bg-${feedbackClass.bg}`" >
          <div class="title-content" v-if="value.incidence" v-tooltip="tooltipText"
               :class="{ 'title-content-invalid': !linkToPlot }"
               @click="showPlot()" role="button">
            <span class="indicator">{{value.disc}}<br>{{ displayedValue }}</span><br>
            <span class="glyphicon" :class="feedbackClass.glyph" aria-hidden="true"></span>
          </div>
          <div class="title-content title-content-invalid" v-else>
            <b>{{value.disc}}</b><br><small>Calcul impossible</small>
          </div>
        </div>
      <div>
        <br>
        <b>Cible de l'indicateur : {{value.limit}}</b> pour {{this.denLabel.label}}
      </div>
    </div>
  </div>
</template>
<script>
import results from '@/sui/data/results'

export default {
  name: 'indicator',

  props: {
    value: {
      type: Object,
      required: true
    }
  },

  methods: {
    showPlot: function () {
      if (this.linkToPlot) {
        const plotData = this.value.plot
        if (plotData == null) {
          return null
        }

        this.$emit(
          'select',
          {
            i: plotData.infType,
            d: plotData.den,
            u: plotData.l,
            p: { disc: plotData.l.disc, spe: plotData.l.spe },
            c: plotData.color
          }
        )
      }
    },

    s: function (d, s = 1) {
      if (d > s) {
        return { s: 's', v: 'sont' }
      }
      return { s: '', v: 'est' }
    }
  },

  computed: {
    displayedValue: function () {
      if (this.value == null || this.value.incidence == null) {
        return null
      }

      return results.fixDecimals(this.value.incidence.incidence)
    },

    linkToPlot: function () {
      if (this.value.plot == null) {
        return null
      }
      return this.value.plot.linkToPlot
    },

    denLabel: function () {
      if (this.value.plot == null) {
        return null
      }
      return this.value.plot.den.info
    },

    isManyEstb: function () {
      if (this.value.incidence == null) {
        return null
      }
      return this.value.incidence.popDetail !== null
    },

    inTarget: function () {
      if (this.isManyEstb) {
        return this.value.incidence.popDetail.inTarget
      }
      return null
    },

    tooltipText: function () {
      const v = this.value
      const inci = v.incidence
      if (inci == null) {
        return null
      }

      let textInfct = `Votre établissement présente
<strong>${inci.numerator}</strong> infection.s pour <strong>${inci.divisor}</strong> ${this.denLabel.unit}.`
      if (this.isManyEstb) {
        const it = inci.popDetail.inTarget
        const to = inci.popDetail.total
        textInfct = `${it} établissement${this.s(it).s} sur ${to} ${this.s(it).v} situé${this.s(it).s} dans la cible.`
      }

      let plot = ''
      if (this.linkToPlot) {
        plot = '<hr><small style="opacity: 0.8">Cliquez pour voir le graphique</small>'
      }
      return `Cet indicateur correspond au <strong>taux d'incidence des ${v.title}</strong>.<br><hr>
              ${textInfct}${plot}`
    },

    feedbackClass: function () {
      if (this.value.valid == null) {
        return {
          bg: 'indicator-na',
          glyph: null
        }
      }
      const isInTarget = this.value.valid

      return {
        bg: isInTarget ? 'indicator-ok' : 'indicator-nok',
        glyph: isInTarget ? 'glyphicon-ok' : 'glyphicon-remove'
      }
    }
  }
}

</script>
<style scoped lang="less">
.indicator {
  font-weight: bold;
}

.glyphicon {
  font-size: 20px;
}

.panel-title {
  border-radius: 0.8rem;
  padding-top: 10px;
  font-size: 16px;
  height: 86px;
}

.panel {
  width: 200px;
  height: 215px;
}

.title-content-invalid {
  cursor: not-allowed;
}
</style>
